import { Check } from "@untitled-ui/icons-react";
import React from "react";
import classNames from "classnames";

export type CheckboxItemProps = {
    type: "checkbox" | "radio"
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;

export const CheckboxItem = React.forwardRef<HTMLInputElement, React.PropsWithChildren<CheckboxItemProps>>(({ id, children, type, className, ...props }, ref) => (
    <div className={classNames('flex flex-1 relative', className)}>
        <input
            ref={ref}
            type={type}
            className='opacity-0 absolute peer pointer-events-none'
            id={id}
            {...props}
        />
        <label className='flex-1 cursor-pointer text-gray-700 text-base font-medium bg-white ring-1 ring-gray-200 rounded p-4 pr-10 hover:ring-primary-300 peer-checked:ring-primary-600 peer-checked:ring-2  peer-focus:shadow-lg peer-focus:shadow-primary-100 transition-all' htmlFor={id}>
            {children}
        </label>
        <span className='absolute top-4 pointer-events-none right-4 w-5 h-5 block ml-auto rounded-full border border-gray-300 peer-checked:bg-primary-600 peer-checked:border-primary-600 flex items-center justify-center text-transparent peer-checked:text-white transition-colors'>
            <Check className='w-3.5 h-3.5' aria-hidden />
        </span>
    </div>
));